import { ArchiveList } from '@components/archiveList';

export const TypeMap: Record<string, React.ComponentType<any>> = {
  ArchiveList,
};
